import uuid from 'uuid';

export default class NotificationModel {
  id;

  type;

  text;

  duration;

  isClosing = false;

  constructor(notificationModel = {
    id: uuid(),
    isClosing: false,
  }) {
    this.id = notificationModel.id;
    this.type = notificationModel.type;
    this.text = notificationModel.text;
    this.duration = notificationModel.duration;
    this.isClosing = notificationModel.isClosing;
  }

  setId(id) {
    this.id = id;
    return this;
  }

  setType(type) {
    this.type = type;
    return this;
  }

  setText(text) {
    this.text = text;
    return this;
  }

  setDuration(duration) {
    this.duration = duration;
    return this;
  }

  setIsClosing(isClosing) {
    this.isClosing = isClosing;
    return this;
  }
}
